import StartsWithStory from '../pages/blog/StartsWithStory';
import type { BlogPost } from '../types/blog';

// Add new blog posts to this array
// The order determines how they appear on the blog page (newest first)
export const blogPosts: BlogPost[] = [
  {
    slug: 'starts-with-story',
    component: StartsWithStory,
    title: "Should it Begin with Story?",
    date: '2025-03-05',
    author: 'Animatronic Database',
    excerpt: "Theme parks often claim 'it all begins with story,' but what if the key to a great park is prioritzing fun over narrative?",
    coverImage: 'https://res.cloudinary.com/dqmcjhu1l/image/upload/v1741457036/themeparkconceptartfake_sv6bk7.jpg',
    tags: ['theme park design', 'Disney', 'Universal', 'Shigeru Miyamoto', 'theme park planning', 'Imagineering', 'WDI']
  }
  // Add new blog posts here
  // {
  //   slug: 'your-post-slug',
  //   component: YourPostComponent,
  //   title: "Your Post Title",
  //   date: '2025-03-15',
  //   author: 'Animatronic Database',
  //   excerpt: "A brief excerpt of your post...",
  //   coverImage: "https://your-cover-image-url.jpg",
  //   tags: ['tag1', 'tag2', 'tag3']
  // }
];